/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reset_Study_Field_TitleInputs */

const en_reset_study_field_title = /** @type {(inputs: Reset_Study_Field_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset study field`)
};

const de_reset_study_field_title = /** @type {(inputs: Reset_Study_Field_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fachbereich zurücksetzen`)
};

/**
* | output |
* | --- |
* | "Reset study field" |
*
* @param {Reset_Study_Field_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const reset_study_field_title = /** @type {((inputs?: Reset_Study_Field_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reset_Study_Field_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_reset_study_field_title(inputs)
	return en_reset_study_field_title(inputs)
});